// RigSentinel · "Update available" banner.
//
// Renders a low-profile fixed banner when the SW lifecycle hook detects a
// new build. One-tap "Update" sends SKIP_WAITING to the waiting worker
// and the tab reloads onto the fresh bundle automatically.

import React from "react";
import { RefreshCcw, X } from "lucide-react";
import { useServiceWorkerUpdate } from "@/hooks/useServiceWorkerUpdate";

export default function UpdateAvailableBanner() {
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();
  const [dismissed, setDismissed] = React.useState(false);

  if (!updateAvailable || dismissed) return null;

  return (
    <div
      data-testid="update-available-banner"
      className="fixed inset-x-0 z-50 flex justify-center pointer-events-none"
      style={{
        top: "calc(env(safe-area-inset-top, 0px) + 12px)",
      }}
    >
      <div
        className="pointer-events-auto inline-flex items-center gap-2.5 px-3 py-2 rounded-full border shadow-2xl"
        style={{
          background: "rgba(14,16,20,0.94)",
          borderColor: "var(--rs-amber, #f5b400)",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          boxShadow: "0 18px 42px rgba(0,0,0,0.55)",
        }}
      >
        <RefreshCcw className="w-3.5 h-3.5 shrink-0" style={{ color: "var(--rs-amber)" }} />
        <span className="text-[11.5px] text-[var(--rs-text-1, #e8edf2)]">
          A new version of RigSentinel is available.
        </span>
        <button
          data-testid="update-banner-apply"
          type="button"
          onClick={applyUpdate}
          className="ml-1 inline-flex items-center gap-1 h-7 px-3 rounded-full text-[11px] font-semibold"
          style={{ background: "var(--rs-amber, #f5b400)", color: "#0A0B0E" }}
        >
          Update now
        </button>
        <button
          data-testid="update-banner-dismiss"
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss update notice"
          className="inline-flex items-center justify-center w-6 h-6 rounded-full"
          style={{
            background: "rgba(255,255,255,0.05)",
            color: "var(--rs-text-2, #c2cad4)",
          }}
        >
          <X className="w-3 h-3" />
        </button>
      </div>
    </div>
  );
}
